import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'
import Select from "react-select"
import { useEffect, useState } from "react"
import customStyles from "../../../components/design/select"

export default function FormUser({submit, isNew, inputChange, handleCheckbox, state, origens}) {
    const { t } = useTranslation()

    const [newpassword, setNewpassword] = useState('')
    const [confpassword, setConfNewpassword] = useState('')
    const [rolesOptions, setRoles] = useState({})
    const [origensOptions, setOrigens] = useState({})
    const [match, setMatch] = useState(true)

    const inputNewPassChange = (e) => {
        setNewpassword(e.target.value)
    }

    const inputConfNewPassChange = (e) => {
        setConfNewpassword(e.target.value)
    }

    const handleSelectRolChange = (e) => {
        inputChange({target:{name: 'rol', value: e.value}})
    }

    const handleSelectOrigenChange = (e) => {
        inputChange({target:{name: 'origen', value: e.value}})
    }

    useEffect(()=>{
        let rolesToUse = [  
            {value: 'Superadmin', label: t('users.Superadmin')},
            {value: "Administrativo", label: t('users.Administrativo')},
            {value: "Encargado", label: t('users.Encargado')},
            {value: "Operario", label: t('users.Operario')}
        ]

        let optionSelected = null

        if(state.rol !== null && state.rol !== undefined){
            optionSelected = rolesToUse.find(rol => rol.value === state.rol)
        }

        if(state.rolEdit !== null && state.rolEdit !== undefined){
            optionSelected = rolesToUse.find(rol => rol.value === state.rolEdit)
        }

        if(state.rol === '' || state.rolEdit === ''){
            optionSelected = null
        }

        setRoles({
            options: rolesToUse, 
            selected: optionSelected
        })
    }, [state.rol, state.rolEdit, t])

    useEffect(()=>{
        let origensToUse = []
        let optionSelected = null

        origens?.forEach(origen => {
            if(origen.type === true){
                let object = {value: origen._id, label: origen.name}
                origensToUse.push(object)

                if (state.origen !== undefined) {
                    if (state.origen === origen._id) {
                        optionSelected = object
                    }
                } else {
                    if (state.origenEdit === origen._id) {
                        optionSelected = object
                    }
                }
            }
        })

        setOrigens({options: origensToUse, selected: optionSelected})
    }, [origens, state.origen, state.origenEdit])

    useEffect(() => {
        if(newpassword.length > 5 && confpassword.length > 5){
            if(newpassword === confpassword){
                inputChange({target:{name: 'password', value: newpassword}})
                setMatch(true)
            }else{
                inputChange({target:{name: 'password', value: ''}})
                setMatch(false)
            }
        }else{
            inputChange({target:{name: 'password', value: ''}})
            setMatch(true)
        }
    // eslint-disable-next-line
    }, [newpassword, confpassword])

    useEffect(() => {
        if(state.password === '' && match === true){
            setNewpassword('')
            setConfNewpassword('')
        }
    }, [state.password, match])

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.firstname')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='firstname' 
                        value={state.firstname || state.firstnameEdit ||  ''}
                        placeholder={t('users.firstname')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.lastname')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='lastname' 
                        value={state.lastname || state.lastnameEdit ||  ''}
                        placeholder={t('users.lastname')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.category')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='category' 
                        value={state.category || state.categoryEdit ||  ''}
                        placeholder={t('users.category')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.nss')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='nss' 
                        value={state.nss || state.nssEdit ||  ''}
                        placeholder={t('users.nss')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.dni')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='dni' 
                        value={state.dni || state.dniEdit ||  ''}
                        placeholder={t('users.dni')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.address')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='address' 
                        value={state.address || state.addressEdit ||  ''}
                        placeholder={t('users.address')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.profile')}</Form.Label>
                    <Select onChange={handleSelectRolChange}
                        name="rol"
                        placeholder={t('users.rol')} 
                        options={rolesOptions.options}
                        value={rolesOptions.selected}
                        styles={customStyles}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.origen')}</Form.Label>
                    <Select onChange={handleSelectOrigenChange}
                        name="origen"
                        placeholder={t('users.origen')}
                        options={origensOptions.options}
                        value={origensOptions.selected}
                        styles={customStyles}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.counter')}</Form.Label>
                    <Form.Check className='float-left mt-3 pe-3' type='checkbox' name='counter' onChange={handleCheckbox} checked={state.counter || false} />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('users.username')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='username' 
                        value={state.username || state.usernameEdit ||  ''}
                        placeholder={t('users.username')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    { isNew === false
                    ?
                        <>
                            <Form.Label className="form-label mt-3">{t('users.newpassword')}</Form.Label>
                            <Form.Control className="form-control"  autoComplete="new-password"
                                type='password'
                                name='password' 
                                value={newpassword}
                                placeholder={t('users.newpassword')}
                                onChange={inputNewPassChange}
                                minLength='6'
                            />
                        </>
                    :
                        <>
                            <Form.Label className="form-label mt-3">{t('users.password')}</Form.Label>
                            <Form.Control className="form-control"  autoComplete="new-password"
                                type='password'
                                name='password' 
                                value={newpassword}
                                placeholder={t('users.newpassword')}
                                onChange={inputNewPassChange}
                                minLength='6'
                                required
                            />
                        </>
                    }
                    { isNew === false
                    ?
                        <>
                            <Form.Label className="form-label mt-3">{t('users.confirmnewpassword')}</Form.Label>
                            <Form.Control className="form-control"
                                type='password'
                                name='passwordconf' 
                                value={confpassword}
                                placeholder={t('users.confirmnewpassword')}
                                onChange={inputConfNewPassChange}
                            />
                        </>
                    :
                        <>
                            <Form.Label className="form-label mt-3">{t('users.confirmpassword')}</Form.Label>
                            <Form.Control className="form-control"
                                type='password'
                                name='passwordconf' 
                                value={confpassword}
                                placeholder={t('users.confirmpassword')}
                                onChange={inputConfNewPassChange}
                                required
                            />
                        </>
                    }
                    { match === false
                    ?
                        <span className="text-danger">* {t('users.passnotmatch')}</span>
                    :
                        <span>&nbsp;</span>
                    }
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    { isNew === false
                    ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('users.actualizar')}</Button>
                    :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('users.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
